export default function (Vue) {
	let authenticatedUser = {}

	Vue.auth = {

		setToken (token, expiration) {
			localStorage.setItem('token', token)
			localStorage.setItem('expiration', expiration)
		},

		setAccount (account) {
			localStorage.setItem('account', account)
			document.cookie = 'account=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
			var cookie = 'account=' + account + ';path=/'
			document.cookie = cookie
		},

		getAccount() {
			return localStorage.getItem('account')
		},

		getToken () {
			var token = localStorage.getItem('token');
			var expiration = localStorage.getItem('expiration');

			if(!token || !expiration)
				return null;
			if(Date.now() > parseInt(expiration)) {
				this.destroyToken();
				return null;
			} else {
				return token;
			}

		},

		destroyToken () {
			localStorage.removeItem('token');
			localStorage.removeItem('expiration');
			localStorage.removeItem('account');
		},

		isAuthenticated () {
			if(this.getToken())
				return true
			else
				return false
		},

		setAuthenticateUser (data) {
			authenticatedUser = data
		},

		getAuthenticatedUser () {
			return authenticatedUser
		},
	}

	Object.defineProperties(Vue.prototype, {
		$auth: {
			get () {
				return Vue.auth;
			}
		}
	})
}


// WEBPACK FOOTER //
// ./src/packages/auth/Auth.js